import { FormContextValues, TranslatableText } from '@dreryk/react-common';
import { Textarea } from '@dreryk/react-components';

const OBJECTIVE_FIELD_NAME = 'objective';
type ObjectiveFormBeanPart = {
   [OBJECTIVE_FIELD_NAME]: string | null;
};
type ObjectiveTextareaProps = {
   readonly register: FormContextValues<ObjectiveFormBeanPart>['register'];
   readonly required: boolean;
   readonly label: TranslatableText;
   readonly placeholder: TranslatableText;
};

export const ObjectiveTextarea = (props: ObjectiveTextareaProps): JSX.Element => {
   return (
      <Textarea
         rows={3}
         maxRows={5}
         maxLength={3600}
         focus={false}
         label={props.label}
         controller={props.register(OBJECTIVE_FIELD_NAME, { required: props.required })}
         placeholder={props.placeholder}
         testId={'objective'}
      />
   );
};
